import { useMutation } from '@tanstack/react-query'

import { updateCorporateDocumentResult } from '@src/api'
import { DefaultApiUpdateCorporateDocumentResultRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useUpdateCorporateDocumentResult = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiUpdateCorporateDocumentResultRequest) =>
      updateCorporateDocumentResult(axiosInstance, params),
  })
}
